import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Features } from '@app/core/user-permissions/user-permissions.model';
import { UserPermissionsService } from '@app/core/user-permissions/user-permissions.service';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, map, startWith, switchMap } from 'rxjs/operators';
import { SmartDevicesService } from '../../service/smart-devices.service';

@Component({
  selector: 'device-thermostat-presets',
  templateUrl: 'device-thermostat-presets.component.html',
  styleUrls: ['device-thermostat-presets.component.scss'],
})
export class DeviceThermostatPresetsComponent implements OnInit {
  private searchSubject = new BehaviorSubject<string>('');

  thermostatPresets$: Observable<{ data: any; loading: boolean; error: any }>;
  hasWriteAccess$ = this.permissionsService.hasAccessTo(Features.PERM_SMARTLOCKS_DASHBOARD_WRITE);

  addingNew$ = new BehaviorSubject<boolean>(false);

  constructor(
    private smartService: SmartDevicesService,
    private permissionsService: UserPermissionsService,
    private router: Router
  ) {}

  ngOnInit() {
    this.hydrateThermostatPresets();
  }

  hydrateThermostatPresets() {
    this.thermostatPresets$ = this.searchSubject.pipe(
      switchMap((searchTerm) =>
        this.smartService.getThermostatPresets(searchTerm).pipe(
          map((res) => ({ data: res, loading: false, error: false })),
          startWith({ data: null, loading: true, error: false }),
          catchError((e) => of({ data: null, loading: false, error: 'Error fetching thermostat presets' }))
        )
      )
    );
  }

  onThermostatPresetsSearchChanged(searchTerm: string) {
    this.searchSubject.next(searchTerm);
  }

  addPreset() {
    this.addingNew$.next(true);
    this.smartService.createThermostatPreset().subscribe(
      (res) => {
        this.addingNew$.next(false);

        // TODO - replace with uuid
        if (res.id) {
          this.router.navigate(['/devices/thermostat-presets', res.id]);
        }
      },
      () => {
        this.addingNew$.next(false);
      }
    );
  }
}
